import { Component, Input, TemplateRef, HostListener } from '@angular/core';

@Component({
  selector: 'app-split-table',
  template: `
    <!-- Split view (wide screen) -->
    @if (shouldSplit) {
      <div
        class="split-table-container"
        [class.split]="shouldSplit"
      >
        <div class="table-section">
          <div class="table-responsive">
            <table class="table mb-0">
              <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              <tbody>
                @for (item of firstHalf; track $index) {
                  <tr>
                    <ng-container
                      *ngTemplateOutlet="rowTemplate; context: { $implicit: item }"
                    ></ng-container>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="table-section">
          <div class="table-responsive">
            <table class="table mb-0">
              <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              <tbody>
                @for (item of secondHalf; track $index) {
                  <tr>
                    <ng-container
                      *ngTemplateOutlet="rowTemplate; context: { $implicit: item }"
                    ></ng-container>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }

    <!-- Single column view (narrow screen) -->
    @if (!shouldSplit) {
      <div class="single-table-container">
        <div class="table-responsive">
          <table class="table mb-0">
            <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
            <tbody>
              @for (item of data; track $index) {
                <tr>
                  <ng-container
                    *ngTemplateOutlet="rowTemplate; context: { $implicit: item }"
                  ></ng-container>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  `,
  styles: [
    `
      .split-table-container {
        display: flex;
        flex-direction: row;
        gap: 1rem;
      }

      .single-table-container {
        display: block;
      }

      .table-section {
        flex: 1;
      }
    `,
  ],
})
export class SplitTableComponent {
  @Input() data: unknown[] = [];
  @Input() headerTemplate!: TemplateRef<unknown>;
  @Input() rowTemplate!: TemplateRef<{ $implicit: unknown }>;

  windowWidth: number = window.innerWidth;

  @HostListener('window:resize')
  onResize() {
    this.windowWidth = window.innerWidth;
  }

  get shouldSplit(): boolean {
    return this.windowWidth > 991;
  }

  get firstHalf(): unknown[] {
    if (!Array.isArray(this.data) || this.data.length === 0) {
      return [];
    }

    const halfLength = Math.ceil(this.data.length / 2);
    return this.data.slice(0, halfLength);
  }

  get secondHalf(): unknown[] {
    if (!Array.isArray(this.data) || this.data.length === 0) {
      return [];
    }

    const halfLength = Math.ceil(this.data.length / 2);
    return this.data.slice(halfLength);
  }
}
